import React, { useState } from "react";
import { X } from "lucide-react";
import { categoryTypeService } from "../../../services/categoryTypeService";

const CategoryTypePopup = ({ onClose, onAdd }) => {
  const [typeName, setTypeName] = useState("");
  const [displayOrder, setDisplayOrder] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!typeName.trim()) {
      setError("Please enter a category type name");
      return;
    }

    const parsedDisplayOrder =
      displayOrder === "" ? undefined : Number(displayOrder);
    if (
      displayOrder !== "" &&
      (!Number.isFinite(parsedDisplayOrder) || parsedDisplayOrder < 0)
    ) {
      setError("Display order must be a non-negative number");
      return;
    }

    setIsSubmitting(true);
    setError("");
    try {
      const payload = { typeName: typeName.trim() };
      if (parsedDisplayOrder !== undefined) {
        payload.displayOrder = parsedDisplayOrder;
      }
      const newType = await categoryTypeService.addCategoryType(payload);
      if (typeof onAdd === "function") {
        onAdd(newType);
      }
      onClose();
    } catch (err) {
      setError(err.message || "Failed to add category type");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>
        <h2 className="text-xl font-bold mb-4">Add New Category Type</h2>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Category Type Name
            </label>
            <input
              type="text"
              value={typeName}
              onChange={(e) => setTypeName(e.target.value)}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter category type name"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Display Order
            </label>
            <input
              type="number"
              min="0"
              value={displayOrder}
              onChange={(e) => setDisplayOrder(e.target.value)}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Lower number appears first"
            />
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-white bg-purple-600 rounded-md hover:bg-purple-700 disabled:bg-purple-300"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Adding..." : "Add Category Type"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryTypePopup;
